module.exports = __webpack_public_path__ + "resources/img/img_turple_m.da0a0c6c4e1e9c43b00e312e5daf02cd.png";